import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { ApiUrl } from './apiUrl';

@Injectable({
  providedIn: 'root'
})
export class ChainsService {

  constructor(private api: ApiService) {}

  getChains() {
    return this.api.getRequest(ApiUrl.CHAINS);
  }

  getChain(chainId: string) {
    return this.api.getRequest(ApiUrl.CHAIN_BY_ID(chainId));
  }

  createChain(data: { chainName: string; description?: string }) {
    return this.api.postRequest(ApiUrl.CHAINS, data);
  }

  updateChain(chainId: string, data: any) {
    return this.api.putRequest(ApiUrl.CHAIN_BY_ID(chainId), data);
  }

  deleteChain(chainId: string) {
    return this.api.deletRequest(ApiUrl.CHAIN_BY_ID(chainId));
  }

  getChainStores(chainId: string) {
    return this.api.getRequest(ApiUrl.CHAIN_STORES(chainId));
  }

  addStoreToChain(chainId: string, storeId: string) {
    return this.api.postRequest(ApiUrl.CHAIN_STORES_ADD(chainId, storeId), {});
  }

  removeStoreFromChain(chainId: string, storeId: string) {
    return this.api.deletRequest(ApiUrl.CHAIN_STORES_ADD(chainId, storeId));
  }

  assignChainManager(chainId: string, adminId: string) {
    return this.api.postRequest(ApiUrl.CHAIN_MANAGERS(chainId), { adminId });
  }

  removeChainManager(chainId: string, managerId: string) {
    return this.api.deletRequest(ApiUrl.CHAIN_MANAGER_BY_ID(chainId, managerId));
  }

  getChainReports(chainId: string, params: any = {}) {
    const queryParams = new URLSearchParams(params).toString();
    const qs = queryParams ? `?${queryParams}` : '';
    return this.api.getRequest(`${ApiUrl.CHAIN_REPORTS(chainId)}${qs}`);
  }

  getChainCategoryReport(chainId: string, params: any = {}) {
    const queryParams = new URLSearchParams(params).toString();
    const qs = queryParams ? `?${queryParams}` : '';
    return this.api.getRequest(`${ApiUrl.CHAIN_CATEGORY_REPORTS(chainId)}${qs}`);
  }

  getChainProductSaleEvents(chainId: string, productId: string, params: any = {}) {
    const queryParams = new URLSearchParams(params).toString();
    const qs = queryParams ? `?${queryParams}` : '';
    return this.api.getRequest(`${ApiUrl.CHAIN_CATEGORY_REPORTS(chainId)}/products/${productId}/sales${qs}`);
  }

  exportChainReports(chainId: string, params: any = {}) {
    const queryParams = new URLSearchParams(params).toString();
    return this.api.getBlobRequest(`${ApiUrl.CHAIN_REPORTS_EXPORT(chainId)}?${queryParams}`);
  }

  exportChainCategoryReports(chainId: string, params: any = {}) {
    const queryParams = new URLSearchParams(params).toString();
    return this.api.getBlobRequest(`${ApiUrl.CHAIN_CATEGORY_REPORTS_EXPORT(chainId)}?${queryParams}`);
  }

  getMyChains() {
    return this.api.getRequest(ApiUrl.MY_CHAINS);
  }

  getChainBranding(chainId: string) {
    return this.api.getRequest(ApiUrl.CHAIN_BRANDING(chainId));
  }

  updateChainBranding(chainId: string, data: any) {
    return this.api.putRequest(ApiUrl.CHAIN_BRANDING(chainId), data);
  }

  uploadChainFiles(chainId: string, formData: FormData) {
    return this.api.postRequest(ApiUrl.CHAIN_UPLOAD(chainId), formData);
  }

  getFullImageUrl(relativePath: string): string {
    if (!relativePath) return '';
    if (relativePath.startsWith('http')) return relativePath;
    const base = this.api.imageUrl.replace(/\/$/, '');
    const p = relativePath.startsWith('/') ? relativePath : '/' + relativePath;
    return base + p;
  }

  // Chain Catalog — Categories
  getChainCategories(chainId: string) {
    return this.api.getRequest(ApiUrl.CHAIN_CATEGORIES(chainId));
  }

  createChainCategory(chainId: string, data: any) {
    return this.api.postRequest(ApiUrl.CHAIN_CATEGORIES(chainId), data);
  }

  updateChainCategory(chainId: string, categoryId: string, data: any) {
    return this.api.putRequest(ApiUrl.CHAIN_CATEGORY_BY_ID(chainId, categoryId), data);
  }

  deleteChainCategory(chainId: string, categoryId: string) {
    return this.api.deletRequest(ApiUrl.CHAIN_CATEGORY_BY_ID(chainId, categoryId));
  }

  // Chain Catalog — Products
  getChainProducts(chainId: string) {
    return this.api.getRequest(ApiUrl.CHAIN_PRODUCTS(chainId));
  }

  createChainProduct(chainId: string, data: any) {
    return this.api.postRequest(ApiUrl.CHAIN_PRODUCTS(chainId), data);
  }

  updateChainProduct(chainId: string, productId: string, data: any) {
    return this.api.putRequest(ApiUrl.CHAIN_PRODUCT_BY_ID(chainId, productId), data);
  }

  deleteChainProduct(chainId: string, productId: string) {
    return this.api.deletRequest(ApiUrl.CHAIN_PRODUCT_BY_ID(chainId, productId));
  }
}
